import React from 'react';

function BetbookTicketIcon() {
    return (
        <svg viewBox="10 9 20 21" className="icon betbook-ticket-icon">
            <defs>
                <filter id="a" width="127%" height="134.2%" x="-13.5%" y="-17.1%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2.5" />
                    <feColorMatrix
                        in="shadowBlurOuter1"
                        result="shadowMatrixOuter1"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>
            <g fill="#FF8000" fillRule="evenodd" filter="url(#a)" transform="translate(0 -5)">
                <path d="m23.714 15.372 1.75 1.75a.41.41 0 0 1 .058.505l-.059.074a1.296 1.296 0 0 0-.002 1.823c.461.46 1.208.496 1.712.106l.121-.106a.405.405 0 0 1 .573 0l1.752 1.752c.5.498.51 1.236.01 1.733l-11.67 11.618c-.5.498-1.25.498-1.75 0l-1.746-1.742a.41.41 0 0 1-.06-.505l.059-.074c.497-.5.497-1.33-.003-1.828a1.314 1.314 0 0 0-1.713-.106l-.12.106a.354.354 0 0 1-.501 0l-1.75-1.743a1.2 1.2 0 0 1 0-1.742L21.96 15.375a1.216 1.216 0 0 1 1.754-.003zm-.875 1.246L11.625 27.863l.925.921.095-.035a2.818 2.818 0 0 1 2.733.536l.14.13a2.8 2.8 0 0 1 .677 2.855l-.06.164.949.947 11.284-11.235-.948-.948-.145.054a2.818 2.818 0 0 1-2.733-.535l-.14-.13a2.791 2.791 0 0 1-.672-2.855l.059-.164-.95-.95zm-1.643 4.53.084.072 2.5 2.5a.75.75 0 0 1-.976 1.133l-.084-.073-2.5-2.5a.75.75 0 0 1 .976-1.133z" />
            </g>
        </svg>
    );
}

export default BetbookTicketIcon;
